module.exports = __webpack_public_path__ + "static/media/m4.a9b7e7c3.svg";